query getLastGeneratedText($input: GetLastGeneratedTextInput!) {
  lastGeneratedText: getLastGeneratedText(input: $input) {
    id
    choices
  }
}
